<template>
  <v-navigation-drawer
    class="elevation-2 app-drawer"
    v-model="$store.state.drawer"
    :mini-variant-width="50"
    mobile-breakpoint="991"
    :mini-variant="miniDrawer"
    :width="miniDrawer ? 50 : 270"
    clipped
    app>
    <div class="order-service" :class="{ 'order-service--mini': miniDrawer }">
      <v-menu
        v-model="orderMenuOpen"
        offset-y
        :offset-x="miniDrawer"
        :nudge-bottom="6"
        :nudge-right="miniDrawer ? 8 : 0"
        min-width="228"
        max-width="260"
        content-class="order-service-menu"
        transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <button
            type="button"
            class="order-service__btn"
            :class="{ 'is-open': orderMenuOpen }"
            :title="$t('btn_add[1]')"
            v-on="on">
            <span class="order-service__plus">
              <d-icon value="add"></d-icon>
            </span>
            <span v-if="!miniDrawer" class="order-service__label">{{ $t('btn_add[0]') }}</span>
            <d-icon v-if="!miniDrawer" class="order-service__chevron" value="arrow-s-down"></d-icon>
          </button>
        </template>
        <div class="order-service-menu__panel">
          <div class="order-service-menu__caption">{{ $t('menu_caption') }}</div>
          <div class="order-service-menu__list">
            <router-link
              v-for="item in orderMenus"
              :key="item.path"
              :to="item.path"
              exact
              class="order-service-menu__item"
              :class="{ 'has-rule': item.dividerBefore }">
              <span class="order-service-menu__icon">
                <d-icon :value="item.icon"></d-icon>
              </span>
              <span class="order-service-menu__name">{{ $t(item.text) }}</span>
              <d-icon class="order-service-menu__go" value="arrow-right"></d-icon>
            </router-link>
          </div>
        </div>
      </v-menu>
    </div>
    <v-list dense>
      <template v-for="(menu, i) in navMenus">
        <v-list-group
          no-action
          v-if="menu.menus"
          :key="menu.text"
          :title="menu.title ? $t(menu.title) : undefined"
          v-bind="menu.bindAttrs"
          @click.native="expandDrawerIfMini">
          <template v-slot:prependIcon>
            <d-icon class="fs-2">{{ menu.icon }}</d-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-title class="menu-l1">{{ menuLabel(menu) }}</v-list-item-title>
          </template>
          <template v-for="(item, j) in menu.menus">
            <v-list-group
              sub-group
              no-action
              v-if="item.menus"
              :key="item.text"
              :title="item.title ? $t(item.title) : undefined"
              v-bind="item.bindAttrs">
              <template v-slot:activator>
                <v-list-item-title class="menu-l2">{{ menuLabel(item) }}</v-list-item-title>
              </template>
              <v-list-item
                v-for="(sub, k) in item.menus"
                :to="sub.path"
                :key="k"
                active-class="nav-item-active">
                <v-list-item-title class="menu-l3">{{ menuLabel(sub) }}</v-list-item-title>
              </v-list-item>
            </v-list-group>
            <v-list-item v-else :to="item.path" :key="j" active-class="nav-item-active">
              <v-list-item-title class="menu-l2">{{ menuLabel(item) }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list-group>
        <v-list-item
          v-else
          :key="i"
          v-bind="menu.bindAttrs"
          :title="$t(menu.title)"
          active-class="nav-item-active">
          <v-list-item-action>
            <d-icon class="fs-2">{{ menu.icon }}</d-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="menu-l1">{{ menuLabel(menu) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
    <template v-slot:append>
      <v-divider></v-divider>
      <div style="justify-content: center; align-items: center; height: 40px" class="d-flex">
        <v-btn icon @click="miniHandler">
          <v-icon>{{ miniDrawer ? 'chevron_right' : 'chevron_left' }}</v-icon>
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { buildNavMenus } from '@/module/navMenu'

export default {
  name: 'LeftDrawer',
  i18n: {
    sharedMessages: {
      en: {
        btn_add: ['Add New Service', 'Discover Popular Services'],
        menu_caption: 'Choose a product'
      },
      zh_CN: {
        btn_add: ['立即订购', '立即订购新服务'],
        menu_caption: '选择要订购的产品'
      }
    }
  },
  data() {
    return {
      miniDrawer: null,
      orderMenuOpen: false
    }
  },
  watch: {
    '$vuetify.breakpoint.name': {
      handler(val) {
        if (['md'].indexOf(val) !== -1) {
          this.miniDrawer = true
        }
      },
      immediate: true
    },
    '$store.state.drawer': {
      handler(val) {
        if (val) {
          this.miniDrawer = false
        }
      }
    }
  },
  computed: {
    countObj() {
      const obj = {}
      this.availablePackages.forEach((o) => {
        obj[o.product__type] = o.count
      })
      return obj
    },
    navMenus() {
      // 菜单树来自共享数据源（与顶部面包屑同源），计数在 menuLabel 渲染层追加
      return buildNavMenus({ $p: this.$p, clientId: this.clientId })
    },
    // 下单入口按 actor 产品权限过滤，避免跳到无权限路由被守卫拦截
    orderMenus() {
      const items = [
        {
          text: 'menu.products.app[0]',
          path: '/applications/ordering',
          permission: 'menu.products.app',
          icon: 'app',
          group: 'app'
        },
        {
          text: 'menu.products.vps[0]',
          path: '/myvps/ordering',
          permission: 'menu.products.vps',
          icon: 'vps',
          group: 'server'
        },
        {
          text: 'menu.products.gpu[0]',
          path: '/gpu-servers/ordering',
          permission: 'menu.products.gpu',
          icon: 'gpu',
          group: 'server'
        },
        {
          text: 'menu.products.dedicated[0]',
          path: '/dedicated-servers/ordering',
          permission: 'menu.products.dedicated',
          icon: 'dedicated',
          group: 'server'
        },
        {
          text: 'menu.products.ssl[0]',
          path: '/ssl/ordering',
          permission: 'menu.products.ssl',
          icon: 'ssl',
          group: 'addon'
        },
        {
          text: 'menu.products.domain[0]',
          path: '/domain/ordering',
          permission: 'menu.products.domain',
          icon: 'domain',
          group: 'addon'
        },
        {
          text: 'menu.products.k8s[0]',
          path: '/k8s-servers/ordering',
          permission: 'menu.products.k8s',
          icon: 'kubernets',
          group: 'addon'
        }
      ]
      const visible = items.filter((item) => this.$p([item.permission]))
      return visible.map((item, i) => {
        const prev = visible[i - 1]
        return {
          ...item,
          dividerBefore: !!(prev && prev.group !== item.group)
        }
      })
    },
    ...mapState('oAuth', ['clientId']),
    ...mapState('client', ['clientInfo']),
    ...mapState('application', ['availablePackages']),
    ...mapGetters('ticket', ['badgeNum'])
  },
  methods: {
    miniHandler() {
      this.miniDrawer = !this.miniDrawer
    },
    expandDrawerIfMini() {
      if (this.miniDrawer) {
        this.miniDrawer = false
      }
    },
    menuLabel(node) {
      const base = this.$t(node.text)
      if (node.countType === 'ticket') {
        return `${base} (${this.badgeNum || 0})`
      }
      if (node.countType) {
        return `${base} (${this.countObj[node.countType] || 0})`
      }
      return base
    }
  }
}
</script>

<style lang="scss">
.v-navigation-drawer__content {
  &::-webkit-scrollbar {
    width: 0;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--v-primary-base);
    border-radius: 0;
  }
}

.order-service {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  padding: 8px 16px 0;

  &--mini {
    padding: 8px 0 0;
  }

  &__btn {
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    padding: 0 10px 0 6px;
    border: 0;
    border-radius: 8px;
    background: var(--v-primary-base);
    color: #fff;
    cursor: pointer;
    font-family: inherit;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.01em;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
    transition: box-shadow 0.15s ease, filter 0.15s ease;

    &:hover {
      filter: brightness(1.05);
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.12);
    }
  }

  &--mini &__btn {
    width: 32px;
    min-width: 32px;
    height: 32px;
    padding: 0;
    justify-content: center;
  }

  &__plus {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.16);
    font-size: 14px;
    flex-shrink: 0;
  }

  &--mini &__plus {
    width: auto;
    height: auto;
    background: transparent;
    font-size: 16px;
  }

  &__label {
    flex: 1;
    margin-left: 8px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__chevron {
    font-size: 12px;
    opacity: 0.88;
    flex-shrink: 0;
    transition: transform 0.18s ease;
  }

  &__btn.is-open &__chevron {
    transform: rotate(180deg);
  }
}

.order-service-menu.v-menu__content {
  border-radius: 12px !important;
  border: 1px solid #e5e9ef;
  box-shadow: 0 8px 24px rgba(17, 24, 39, 0.08) !important;
  overflow: hidden;
}

.order-service-menu {
  &__panel {
    padding: 8px;
    background: #fff;
  }

  &__caption {
    padding: 4px 8px 8px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.4;
    color: #6b7280;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 7px 8px;
    border-radius: 8px;
    text-decoration: none;
    color: inherit;
    transition: background-color 0.12s ease;

    &.has-rule {
      margin-top: 6px;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: -4px;
        left: 8px;
        right: 8px;
        height: 1px;
        background: #f0f0f5;
      }
    }

    &:hover {
      background: #f5f7fa;
      text-decoration: none;

      .order-service-menu__icon {
        background: #fff;
        border-color: #d7dde8;
        color: var(--v-primary-base);
      }

      .order-service-menu__name {
        color: #1a1a1a;
      }

      .order-service-menu__go {
        opacity: 1;
        transform: translateX(0);
        color: var(--v-primary-base);
      }
    }

    &.router-link-exact-active {
      background: #f5f7fa;

      .order-service-menu__icon {
        color: var(--v-primary-base);
        background: #fff;
        border-color: var(--v-primary-base);
      }

      .order-service-menu__name {
        color: var(--v-primary-base);
        font-weight: 600;
      }
    }
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #e5e9ef;
    background: #f5f7fa;
    color: #374151;
    font-size: 16px;
    flex-shrink: 0;
    transition: color 0.12s ease, background-color 0.12s ease, border-color 0.12s ease;
  }

  &__name {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    font-weight: 500;
    color: #374151;
    line-height: 1.3;
  }

  &__go {
    margin-left: auto;
    font-size: 12px;
    color: #c5ccd8;
    opacity: 0;
    transform: translateX(-4px);
    transition: opacity 0.12s ease, transform 0.12s ease, color 0.12s ease;
  }
}

.app-drawer {
  .v-list {
    // ===== 分级视觉：缩进 + 字重 + 颜色三级递减，强化层级可读性 =====
    // 一级：分组头 / 独立入口——最深，字重适中（不宜过粗）
    .menu-l1 {
      font-size: 14px;
      font-weight: 400;
      color: #262931;
      letter-spacing: 0.1px;
    }
    // 二级：分组内页面 / 子分组头
    .menu-l2 {
      font-size: 13px;
      font-weight: 400;
      color: #5b6472;
    }
    // 三级：子分组内页面——最轻、最浅
    .menu-l3 {
      font-size: 13px;
      font-weight: 400;
      color: #808a97;
    }

    // 一级图标与文字靠近：收窄图标容器与标题的间距
    .v-list-item__action:first-child {
      margin-right: 14px;
      min-width: 24px;
    }

    // 逐级缩进（覆盖 Vuetify no-action 默认缩进）
    .v-list-group__items > .v-list-item {
      padding-left: 72px;
    }
    .v-list-group--sub-group > .v-list-group__header {
      padding-left: 72px;
    }
    .v-list-group--sub-group .v-list-group__items > .v-list-item {
      padding-left: 92px;
    }

    // 层级引导线：嵌套分组左侧加细竖线，直观表达从属关系
    .v-list-group__items {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 2px;
        bottom: 2px;
        left: 30px;
        width: 1px;
        background-color: #ececec;
      }
    }
    .v-list-group--sub-group .v-list-group__items::before {
      left: 50px;
    }

    // 激活项：主色文字 + 左侧色条（优先级需高于上面的分级颜色）
    .nav-item-active {
      color: var(--v-primary-base);

      .v-list-item__title {
        color: var(--v-primary-base);
        font-weight: 600;
      }

      &:after {
        position: absolute;
        left: 0;
        content: '';
        width: 6px;
        height: 100%;
        background-color: var(--v-primary-base);
      }
    }

    .v-list-item:hover {
      color: var(--v-primary-base);

      // hover 时文字也变主色（分级设置了显式颜色，需在此覆盖）
      .v-list-item__title {
        color: var(--v-primary-base);
      }

      &:before {
        opacity: 0.12;
      }
    }

    .v-list-item:not(.v-list-group__header) {
      height: 50px;
    }

    .v-list-group .v-list-group__header .v-list-group__header__prepend-icon {
      margin-top: 12px;
      margin-bottom: 12px;
      // 一级分组头：图标靠近文字
      margin-right: 14px;
      min-width: 24px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
  }

  // 迷你收起态：隐藏引导线，避免窄栏出现悬空竖线；图标在 50px 窄栏内水平居中
  &.v-navigation-drawer--mini-variant {
    .v-list-group__items::before {
      display: none;
    }

    .v-list-item,
    .v-list-group__header {
      justify-content: center;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .v-list-item__action,
    .v-list-group__header__prepend-icon {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }

    // 收起态不展示展开箭头，避免把图标挤偏
    .v-list-group__header__append-icon {
      display: none;
    }
  }
}
</style>
